export const errorModalConfig: ModalContent = {
  title: 'Something went wrong',
  body: 'Chat failed to load, please refresh the page and try again.',
  cta: {
    text: 'OK',
    callback: () => {}
  }
};
